// English translations for the settings page (French string -> English).
// NB: shared strings (Enregistrer, Supprimer, Ajouter, Chargement…, Livré…)
// live in ./common — do NOT duplicate them here.
const m: Record<string, string> = {
  // ── Section nav + clusters ─────────────────────────────────────────────
  'Réduire {label}': 'Collapse {label}',
  'Paramètres': 'Settings',
  'Réglages du studio Storiz': 'Storiz studio settings',
  'Album & Prix': 'Album & Pricing',
  'Album & Tarification': 'Album & Pricing',
  'Impression': 'Printing',
  "Paramètres d'impression": 'Print settings',
  'Fiche de montage': 'Assembly sheet',
  "PDF universel pour l'atelier": 'Universal PDF for the workshop',
  'Imprimeur': 'Printer',
  'Contact & envoi': 'Contact & sending',
  'Livraison': 'Delivery',
  'AMEEX par défaut': 'AMEEX defaults',
  'Ville, COD, étiquettes': 'City, COD, labels',
  'Marque & Studio': 'Brand & Studio',
  'Identité de marque': 'Brand identity',
  'Catégories de couvertures': 'Cover categories',
  '{n} catégorie': '{n} category',
  '{n} catégories': '{n} categories',
  "Ressources de l'éditeur": 'Editor resources',
  'Polices · Icônes': 'Fonts · Icons',
  'Marketing': 'Marketing',
  'Pixels de tracking': 'Tracking pixels',
  'Facebook · TikTok · GA4 · GTM · Clarity': 'Facebook · TikTok · GA4 · GTM · Clarity',
  'Système': 'System',
  'Rétention des fichiers': 'File retention',
  'Nettoyage automatique': 'Automatic cleanup',

  // ── Pixels section ─────────────────────────────────────────────────────
  "Collez les IDs des pixels configurés dans Shopify pour suivre l'activité dans l'app (Facebook, TikTok, Google) dans les mêmes tableaux de bord.":
    'Paste the pixel IDs configured in Shopify to track in-app activity (Facebook, TikTok, Google) in the same dashboards.',
  'Facebook / Meta Pixel': 'Facebook / Meta Pixel',
  'Ads Manager → Events Manager → ID du pixel': 'Ads Manager → Events Manager → Pixel ID',
  'TikTok Pixel': 'TikTok Pixel',
  'TikTok Events Manager → ID du pixel': 'TikTok Events Manager → Pixel ID',
  'Google Analytics 4': 'Google Analytics 4',
  'GA Admin → Data Streams → ID de mesure': 'GA Admin → Data Streams → Measurement ID',
  'Google Tag Manager (optionnel)': 'Google Tag Manager (optional)',
  'Alternative à GA4 direct. Si vous gérez les tags dans GTM.':
    'Alternative to direct GA4. Use if you manage tags in GTM.',
  'Microsoft Clarity': 'Microsoft Clarity',
  'Clarity Project → Settings → Overview → Project ID. Active session replays + heatmaps.':
    'Clarity Project → Settings → Overview → Project ID. Enables session replays + heatmaps.',
  '🧪 Envoyer un événement test': '🧪 Send a test event',
  'Les scripts se chargent au prochain rechargement de la page pour les nouveaux IDs.':
    'Scripts load on the next page reload for new IDs.',
  'Vérifiez le pixel avec l’extension Chrome': 'Verify the pixel with the Chrome extension',
  'ou regardez la console DevTools (logs': 'or check the DevTools console (logs',
  'Tester': 'Test',
  '{source} non chargé. Enregistrez et rafraîchissez d’abord.':
    '{source} not loaded. Save and refresh first.',
  'Événement « storiz_test_{source} » envoyé. Vérifiez dans Events Manager / DevTools console.':
    'Event “storiz_test_{source}” sent. Check Events Manager / DevTools console.',

  // ── Branding section ───────────────────────────────────────────────────
  'Logo et pages fixes qui apparaissent dans chaque album':
    'Logo and fixed pages that appear in every album',
  'Logo Storiz': 'Storiz logo',
  'PNG ou SVG, placé sur la couverture + tranche': 'PNG or SVG, placed on the cover + spine',
  "Page d'intro": 'Intro page',
  "Première page de l'album, ajoutée automatiquement": 'First page of the album, added automatically',
  "Page d'outro": 'Outro page',
  "Dernière page de l'album, ajoutée automatiquement": 'Last page of the album, added automatically',
  'Retirer': 'Remove',
  'Voir le fichier': 'View file',
  'Remplacer': 'Replace',
  'Téléverser': 'Upload',

  // ── Categories section ─────────────────────────────────────────────────
  'Organisez vos couvertures par thèmes (Voyage, Anniversaire...)':
    'Organize your covers by themes (Travel, Birthday...)',
  'Supprimer la catégorie « {label} » ?': 'Delete the category “{label}”?',
  'Ajouter une catégorie': 'Add a category',
  'Icône': 'Icon',
  'Slug': 'Slug',
  'Libellé FR': 'FR label',
  'Anniversaire': 'Birthday',

  // ── Album settings section ─────────────────────────────────────────────
  'Pages par défaut, prix de vente, coût de revient et acompte client':
    'Default pages, selling price, cost price and customer deposit',
  'Pages par défaut': 'Default pages',
  '= {papers} feuilles recto/verso': '= {papers} double-sided sheets',
  'Prix page supp. (MAD)': 'Extra page price (MAD)',
  'Facturé au-delà de {pageCount} pages': 'Charged beyond {pageCount} pages',
  'Coût de revient / livre (MAD)': 'Cost price / book (MAD)',
  'Utilisé pour calculer le bénéfice': 'Used to calculate profit',
  'Acompte client (MAD)': 'Customer deposit (MAD)',
  'Payé par virement avant livraison ; déduit du COD AMEEX':
    'Paid by bank transfer before delivery; deducted from the AMEEX COD',

  // ── AMEEX defaults section ─────────────────────────────────────────────
  'Livraison AMEEX — valeurs par défaut': 'AMEEX delivery — defaults',
  'Pré-remplit le formulaire de colis pour chaque commande. Modifiable par commande si besoin.':
    'Pre-fills the parcel form for every order. Editable per order if needed.',
  'Nature de produit (champ « product » envoyé à AMEEX)':
    'Product type (the “product” field sent to AMEEX)',
  'Fragile par défaut': 'Fragile by default',
  'Coche la case « Fragile » sur AMEEX (recommandé pour les albums)':
    'Ticks the “Fragile” box on AMEEX (recommended for albums)',
  "Autoriser l'ouverture par le client": 'Allow the customer to open',
  "Si le colis est refusé, des frais de refus s'appliquent — laisser désactivé":
    'If the parcel is refused, refusal fees apply — leave disabled',
  "Autoriser l'essayage par le client": 'Allow the customer to try on',
  'Inutile pour un album imprimé — laisser désactivé':
    'Pointless for a printed album — leave disabled',
  "Format d'étiquette d'impression batch": 'Batch print label format',
  'Thermique 10×10 cm (Label_100_100)': 'Thermal 10×10 cm (Label_100_100)',
  'A4 — une étiquette par page': 'A4 — one label per page',
  'A4 — 8 étiquettes par page': 'A4 — 8 labels per page',
  'Utilisé par le bouton « Confirmer + imprimer tout » du tableau Livraison.':
    'Used by the “Confirm + print all” button on the Delivery board.',
  'Enregistrement…': 'Saving…',
  '✓ Enregistré': '✓ Saved',
  'Échec — voir console': 'Failed — see console',

  // ── Print settings section ─────────────────────────────────────────────
  'Imprimante et réglages PDF pour la génération': 'Printer and PDF settings for generation',
  'Imprimante': 'Printer',
  'Konica Minolta bizhub (bureau, A3 laser)': 'Konica Minolta bizhub (office, A3 laser)',
  'Konica Minolta AccurioPress (pro, SRA3)': 'Konica Minolta AccurioPress (pro, SRA3)',
  "Epson L1850 / L18050 (photo, A3 jet d'encre)": 'Epson L1850 / L18050 (photo, A3 inkjet)',
  'Imprimante A4 standard': 'Standard A4 printer',
  'Personnalisé': 'Custom',
  'Sélectionner une imprimante configure automatiquement les réglages ci-dessous.':
    'Selecting a printer automatically configures the settings below.',
  'Format du PDF': 'PDF format',
  'A4 — une page par feuille': 'A4 — one page per sheet',
  'A3 — deux pages par feuille (reliure à plat)': 'A3 — two pages per sheet (flat binding)',
  'Résolution images (DPI)': 'Image resolution (DPI)',
  '150 DPI — rapide, bureau': '150 DPI — fast, office',
  '300 DPI — haute qualité, photo': '300 DPI — high quality, photo',
  'Fond perdu (mm)': 'Bleed (mm)',
  '0 = sans fond perdu': '0 = no bleed',
  'Traits de coupe': 'Crop marks',

  // ── Assembly template section ──────────────────────────────────────────
  'Fiche de montage — couverture rigide': 'Assembly sheet — hardcover',
  "Dimensions des cartons rigides. La fiche de montage (téléchargeable sur chaque commande) n'est jamais imprimée sur la couverture. Réglage global : s'applique à toutes les commandes, anciennes et nouvelles.":
    'Rigid board dimensions. The assembly sheet (downloadable on each order) is never printed on the cover. Global setting: applies to all orders, past and new.',
  'Carton — largeur (mm)': 'Board — width (mm)',
  'Carton — hauteur (mm)': 'Board — height (mm)',
  'Dos — largeur (mm)': 'Spine — width (mm)',
  'Jeu de charnière (mm)': 'Hinge gap (mm)',
  'Rempli / turn-in (mm)': 'Turn-in (mm)',
  'Épaisseur de chant (mm)': 'Edge thickness (mm)',
  'Zone de sécurité (mm)': 'Safe zone (mm)',
  'Épaisseur carton (mm)': 'Board thickness (mm)',
  'Taille du vinyle calculée :': 'Computed vinyl size:',
  '(= 2·carton + 2·jeu + dos + 2·chant + 2·rempli + 2·zone de sécurité)':
    '(= 2·board + 2·gap + spine + 2·edge + 2·turn-in + 2·safe zone)',
  'Recalculée automatiquement si le dos ou la zone de sécurité change.':
    'Recomputed automatically if the spine or safe zone changes.',
  'Centrage :': 'Centring:',
  'gauche/droite,': 'left/right,',
  'haut/bas. Dos centré, jeu de': 'top/bottom. Spine centred, gap of',
  'de chaque côté.': 'on each side.',
  'Aperçu de la fiche': 'Preview the sheet',

  // ── File retention section ─────────────────────────────────────────────
  'Quand supprimer les photos et PDFs de Supabase Storage':
    'When to delete photos and PDFs from Supabase Storage',
  '📷 Photos clients': '📷 Customer photos',
  'Supprimer les photos': 'Delete photos',
  'Manuellement uniquement': 'Manually only',
  "Après X heures suivant l'upload": 'X hours after upload',
  'Après livraison de la commande': 'After order delivery',
  'Délai avant suppression': 'Delay before deletion',
  'heures': 'hours',
  '({days} jours)': '({days} days)',
  'Photos supprimées automatiquement quand le statut de la commande passe à':
    'Photos deleted automatically when the order status changes to',
  'Les photos ne seront jamais supprimées automatiquement.':
    'Photos will never be deleted automatically.',
  '📄 PDFs générés': '📄 Generated PDFs',
  'Supprimer les PDFs': 'Delete PDFs',
  'PDFs supprimés automatiquement avec les photos lors du statut':
    'PDFs deleted automatically with the photos at the status',
  'Les PDFs restent disponibles indéfiniment (liens valides 1 an).':
    'PDFs stay available indefinitely (links valid for 1 year).',
  'Lancer le nettoyage maintenant ? Les fichiers supprimés ne peuvent pas être récupérés.':
    'Run cleanup now? Deleted files cannot be recovered.',
  'Erreur lors du nettoyage. Réessayez.': 'Cleanup error. Please try again.',
  '🗑️ Nettoyer maintenant': '🗑️ Clean up now',
  '✓ {photos} photos et {pdfs} PDFs supprimés': '✓ {photos} photos and {pdfs} PDFs deleted',

  // ── Printer section ────────────────────────────────────────────────────
  "Contact de l'imprimeur pour l'action « Envoyer à l'imprimeur » + tarifs par défaut des lots d'impression.":
    'Printer contact for the “Send to printer” action + default rates for print batches.',
  'Prix / feuille A3 (MAD)': 'Price / A3 sheet (MAD)',
  '70g recto-verso = 4 pages A4': '70g double-sided = 4 A4 pages',
  'Prix / couverture (MAD)': 'Price / cover (MAD)',
  'Modifiable par lot (gros volume)': 'Editable per batch (high volume)',
  'Livraison forfait (MAD)': 'Flat delivery (MAD)',
  'Si AMEEX ne donne pas le vrai prix': 'If AMEEX does not give the real price',
  "Email de l'imprimeur": 'Printer email',
  "Envoyer un email (lien de téléchargement du zip) à l'imprimeur":
    'Send an email (zip download link) to the printer',
  "WhatsApp de l'imprimeur": 'Printer WhatsApp',
  "Ouvrir un lien WhatsApp pré-rempli vers l'imprimeur":
    'Open a pre-filled WhatsApp link to the printer',
  "L'email part via MailChannels. Configurez les secrets du worker":
    'The email is sent via MailChannels. Configure the worker secrets',
  "pour l'activer ; sans cela, l'action génère quand même le zip et le lien WhatsApp.":
    'to enable it; without them, the action still generates the zip and the WhatsApp link.',

  // ── Editor resources section ───────────────────────────────────────────
  "Polices et icônes disponibles dans l'éditeur d'album.":
    'Fonts and icons available in the album editor.',
  'Polices': 'Fonts',
  'Icônes et éléments': 'Icons and elements',
  "Les polices ajoutées ici apparaissent dans le sélecteur du toolbar texte de l'éditeur. Utilisez l'URL":
    'Fonts added here appear in the editor text toolbar selector. Use the URL',
  'fournie par Google Fonts.': 'provided by Google Fonts.',
  'Nom (ex. Lobster)': 'Name (e.g. Lobster)',
  'Ajout…': 'Adding…',
  'Erreur': 'Error',
  'Aucune police personnalisée pour le moment.': 'No custom fonts yet.',
  'Supprimer « {name} » ?': 'Delete “{name}”?',
  'Téléversez un fichier SVG ou collez son code. Les icônes sont disponibles dans le panneau "Éléments" de l\'éditeur client.':
    'Upload an SVG file or paste its code. Icons are available in the "Elements" panel of the customer editor.',
  'Nom (ex. Coeur)': 'Name (e.g. Heart)',
  'Étiquettes (séparées par virgules)': 'Tags (comma-separated)',
  'Téléverser SVG': 'Upload SVG',
  '… ou collez le code ci-dessous': '… or paste the code below',
  "Ajouter l'icône": 'Add icon',
  'Aperçu': 'Preview',
  'Aucune icône pour le moment.': 'No icons yet.',
  // ── Photo deletion (migration 280) ──
  'Supprimer après la livraison': 'Delete after delivery',
  'Photos envoyées sur WhatsApp': 'Photos sent on WhatsApp',
  'Garder (ne pas supprimer)': 'Keep (do not delete)',
  'Test : compter seulement, ne rien supprimer': 'Test: count only, delete nothing',
  'Supprimer aussi': 'Delete them too',
  'Supprimées {days} jours après la livraison. Jamais pendant une réclamation ouverte, ni si le client demande de les garder.': 'Deleted {days} days after delivery. Never while a complaint is open, nor if the client asks to keep them.',
  "L'assistant peut promettre aux clients que leurs photos sont supprimées automatiquement.": 'The assistant may promise clients that their photos are deleted automatically.',
  "L'assistant ne promet pas la suppression tant que les photos WhatsApp ne sont pas supprimées aussi.": 'The assistant does not promise deletion until WhatsApp photos are deleted too.',
  'Dernières suppressions': 'Latest deletions',
  'test — {n} photos WhatsApp seraient supprimées': 'test — {n} WhatsApp photos would be deleted',
  '{a} photos album · {w} photos WhatsApp supprimées': '{a} album photos · {w} WhatsApp photos deleted',
  '(J+{d})': '(day +{d})',
};
export default m;
